import { Module } from "vuex";
import { RootState } from "../types";
import { CandidatesInt } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: [],
} as CandidatesInt;

export const candidates: Module<CandidatesInt, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
